import { render, staticRenderFns } from "./spec__form.vue?vue&type=template&id=48ca53c2"
import script from "./spec__form.vue?vue&type=script&lang=js"
export * from "./spec__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports